import {
  Box,
  Button,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Add, SearchOutlined } from '@mui/icons-material';
import { useEffect, useRef, useState } from 'react';
import { PermissionFilter } from '../../model/permission.model';
import { useDebounce } from '../../../../hooks/use-debounce';

interface IProps {
  filter: PermissionFilter | null;
  onFilterChange: (filter?: PermissionFilter | null) => void;
  handleOpenDialog: () => void;
}

const ACTIVE_OPTIONS = [
  { label: 'ທັງໝົດ', value: 'all' },
  { label: 'ໃຊ້ງານ', value: 'true' },
  { label: 'ປິດໃຊ້ງານ', value: 'false' },
];

const PermissionHeader = ({ filter, onFilterChange, handleOpenDialog }: IProps) => {
  const [code, setCode] = useState('');
  const debouncedCode = useDebounce(code, 500);
  // The page loads the first list on mount; only refetch once the box is used.
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    const updated = { ...filter, skip: 0 };
    if (debouncedCode.trim() === '') {
      delete updated.code;
    } else {
      updated.code = debouncedCode.trim();
    }
    onFilterChange(updated);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedCode]);

  const activeValue =
    filter?.is_active === undefined ? 'all' : filter.is_active ? 'true' : 'false';

  return (
    <Box sx={{ py: 3, px: 3 }}>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            value={code}
            onChange={(e) => setCode(e.target.value)}
            size="small"
            placeholder="ຄົ້ນຫາລະຫັດສິດທິ (ຕ.ຢ. mseg:role)"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchOutlined />
                </InputAdornment>
              ),
              style: { borderRadius: '30px' },
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <FormControl size="small" fullWidth>
            <Select
              value={activeValue}
              style={{ borderRadius: '30px' }}
              onChange={(e) => {
                const updated = { ...filter, skip: 0 };
                if (e.target.value === 'all') {
                  delete updated.is_active;
                } else {
                  updated.is_active = e.target.value === 'true';
                }
                onFilterChange(updated);
              }}
            >
              {ACTIVE_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Box flex={1} />
        <Grid
          item
          xs={12}
          md={3}
          sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'end' }}
        >
          <Button
            variant="contained"
            sx={{ width: { md: '84%', xs: '100%' }, borderRadius: 5 }}
            onClick={handleOpenDialog}
            fullWidth
          >
            <Add /> ເພີ່ມສິດທິ
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PermissionHeader;
